(function () {
    // Lees instelling uit shop metafield via een data-attribuut dat je in het theme zet
    const enabled = document.documentElement.dataset.availabilitySort === "true";
    if (!enabled) return;
    if (!window.location.pathname.startsWith("/collections/")) return;
  
    const SORT_ATTR = "data-availability-sorted";
    if (document.documentElement.hasAttribute(SORT_ATTR)) return;
    document.documentElement.setAttribute(SORT_ATTR, "1");
  
    function sortProducts() {
      // Zoek alle productkaarten — pas selector aan op jouw theme
      const grid = document.querySelector(
        ".collection-grid, .product-grid, [class*='product-list'], ul.grid"
      );
      if (!grid) return;
  
      const cards = [...grid.children];
      if (cards.length < 2) return;
  
      const available = cards.filter(
        (c) => !c.querySelector("[data-sold-out], .sold-out, .badge--sold-out, [class*='sold-out']")
      );
      const soldOut = cards.filter(
        (c) => !!c.querySelector("[data-sold-out], .sold-out, .badge--sold-out, [class*='sold-out']")
      );
  
      // Als alles of niets sold-out is, niet ingrijpen
      if (!soldOut.length || !available.length) return;
  
      // Rebuild grid: beschikbaar eerst, dan uitverkocht
      const fragment = document.createDocumentFragment();
      [...available, ...soldOut].forEach((c) => fragment.appendChild(c));
      grid.appendChild(fragment);
    }
  
    // Run direct + na dynamische loads (infinite scroll / filtering)
    sortProducts();
  
    const observer = new MutationObserver(() => {
      sortProducts();
    });
  
    const grid = document.querySelector(
      ".collection-grid, .product-grid, [class*='product-list'], ul.grid"
    );
    if (grid) {
      observer.observe(grid, { childList: true, subtree: false });
    }
  })();